import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

function PanicIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 122.02 121.32" {...props}>
      <path
        d="m 60.905 10.12 c -4.985 0 -9.185 2.753 -15.424 5.966 a 107.12 107.12 0 0 1 -27.674 9.966 l -1.587 0.38 v 1.588 c 0 31.117 10.909 51.912 21.835 64.805 s 22.025 18.026 22.025 18.026 l 0.889 0.444 l 0.889 -0.444 s 43.732 -22.596 43.732 -82.831 v -1.588 l -1.587 -0.381 a 107.114 107.114 0 0 1 -27.674 -9.965 c -6.237 -3.213 -10.442 -5.966 -15.424 -5.966 z m 0 4.062 c 3.34 0 7.212 2.245 13.583 5.522 a 114.372 114.372 0 0 0 26.912 9.839 c -0.745 55.077 -37.948 75.739 -40.559 77.119 c -1.262 -0.611 -10.053 -5.007 -19.74 -16.44 c -10.211 -12.051 -20.319 -31.434 -20.692 -60.679 a 114.373 114.373 0 0 0 26.911 -9.839 c 6.373 -3.276 10.245 -5.522 13.585 -5.522 z m -2.6 20.692 a 0.742 0.742 0 0 0 -0.762 0.762 v 34.72 a 0.689 0.689 0 0 0 0.762 0.7 h 5.515 a 0.693 0.693 0 0 0 0.762 -0.7 v -34.72 a 0.743 0.743 0 0 0 -0.762 -0.762 z m 0 43.288 a 0.693 0.693 0 0 0 -0.762 0.7 v 6.284 a 0.689 0.689 0 0 0 0.762 0.7 h 5.515 a 0.693 0.693 0 0 0 0.762 -0.7 v -6.285 a 0.693 0.693 0 0 0 -0.762 -0.7 z"
        fill="currentColor"
        stroke="currentColor"
      />
    </SvgIcon>
  );
}

export default PanicIcon;
